exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line-chart[data-v-1a81d946] {\n  width: 90%;\n  height: calc(100% - 56px);\n  margin-left: 50px;\n  position: relative;\n}\n.chart-box[data-v-1a81d946] {\n  height: 100%;\n}\n.chart-box .title[data-v-1a81d946] {\n  width: 100%;\n  font-size: 16px;\n  padding: 10px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  font-weight: 700;\n  color: #333333;\n  margin-top: 20px;\n}\n.tc[data-v-1a81d946] {\n  color: #fff;\n}", ""]);

// exports
